export const SAVE = 'stepTripCancellationTravellerTugo.SAVE';
export const VALUE_CHANGED = 'stepTripCancellationTravellerTugo.VALUE_CHANGED';
export const LOAD = 'stepTripCancellationTravellerTugo.LOAD';
export const NEXT = 'stepTripCancellationTravellerTugo.NEXT';
export const RESET = 'stepTripCancellationTravellerTugo.RESET';
export const RESET_FORM_STATE = 'stepTripCancellationTravellerTugo.RESET_FORM_STATE';




// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.TripCancellationTraveller/constants.js